module.exports = ".modal-title {\n  display: inline; }\n\n.btn-secondary {\n  color: #000000 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/addusermodal.component.scss
// module id = 588
// module chunks = 1